module.exports = "<p>\n  card-ico works!\n</p>\n"